<template>
    <Form
        :errors="errors"
        :product="product"
        :product-groups="productGroups"
        :dns-templates="dnsTemplates"
        :accounting-products="accountingProducts"
        :intercompany-accounting-products="intercompanyAccountingProducts"
        :fulfillment-strategies="fulfillmentStrategies"
        :is-short-termination-period-set="isShortTerminationPeriodSet"
        :invoice-behaviours="invoiceBehaviours"
        :default-tenant-language="defaultTenantLanguage"
        :tenant-languages="tenantLanguages"
        :is-invoice-before-renewal-enabled="isInvoiceBeforeRenewalEnabled"
        :preselected-downgrades="preselectedDowngrades"
        :preselected-upgrades="preselectedUpgrades"
        :termination-rules="terminationRules"
        :product-classes="productClasses"
        :billing-types="billingTypes"
        :linked-products="linkedProducts"
        :requires-domain-options="requiresDomainOptions"
        @form-submitted="submitData"
    />
</template>

<script>
import Form from '~@/Components/Products/ProductAddons/Form'

export default {
    name: 'ProductAddonsUpdate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        product: {
            type: Object,
            default () {
                return {}
            }
        },
        productGroups: {
            type: Array,
            default () {
                return []
            }
        },
        dnsTemplates: {
            type: Array,
            default () {
                return []
            }
        },
        accountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        intercompanyAccountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        fulfillmentStrategies: {
            type: Array,
            default () {
                return []
            }
        },
        invoiceBehaviours: {
            type: Array,
            default () {
                return []
            }
        },
        isShortTerminationPeriodSet: {
            type: Boolean,
            default: () => { return false }
        },
        defaultTenantLanguage: {
            type: String,
            default: ''
        },
        tenantLanguages: {
            type: Array,
            default: () => { return [] }
        },
        isInvoiceBeforeRenewalEnabled: {
            type: Boolean,
            default: false
        },
        preselectedDowngrades: {
            type: Array,
            default () {
                return []
            }
        },
        preselectedUpgrades: {
            type: Array,
            default () {
                return []
            }
        },
        terminationRules: {
            type: Array,
            default: () => { return [] }
        },
        productClasses: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        requiresDomainOptions: {
            type: Array,
            default: () => { return [] }
        },
        linkedProducts: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        submitData (form) {
            const newForm = { ...form }
            newForm.selectedDowngrades = newForm.selectedDowngrades.map((val) => val.value)
            newForm.selectedUpgrades = newForm.selectedUpgrades.map((val) => val.value)

            newForm.put(this.$route('products.product-addons.update', this.product.id))
        }
    }
}
</script>
